import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { productionOrderDetailsBatchConfig } from './config';

const ProductionOrderDetailsBatchStack = createStackNavigator();

const ProductionOrderDetailsBatchNavigator = () => {
  return (
    <ProductionOrderDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {productionOrderDetailsBatchConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsBatchStack.Navigator>
  );
};

export { ProductionOrderDetailsBatchNavigator };
